import React from "react";
import { assets } from "../../Assets/assets";

const LabelHeading = ({ label, heading, position, text, light = false }) => {
  return (
    <article data-aos="fade-up" data-aos-duration="1000"
      className={`${position === "left" ? "xl:w-[70%] lg:w-full" : "text-center w-full md:w-[60%] xl:w-[45%] mx-auto"
        } space-y-3 font-SpaceGrotesk `}
    >
      {position === "left" ? (
        <h6 className="font-bold flex items-center gap-2 text-sm text-primaryFadedColor"><img className="h-3" src={assets.bluearrow} alt="arrow" />{label}</h6>
      ) : (
        <h6 className="font-bold text-sm justify-center flex items-center gap-2 text-primaryFadedColor"><img className="h-3" src={assets.bluearrow} alt="arrow" /> {label} <img className="h-3 rotate-180" src={assets.bluearrow} alt="" /></h6>
      )}
      <h1 className={` ${light ? 'text-white' : 'text-primaryColor'} capitalize text-2xl md:text-3xl lg:text-4xl font-bold`}>
        {heading}
      </h1>
      <p className="text-secondaryTextColor">{text}</p>
    </article>
  );
};

export default LabelHeading;
